import { IDispatchAxiosAction } from 'models/dispatch-action.interface';
import { IMarketFilters } from 'models/market/i-market-filters.interface';
import { MarketStatus } from 'enums/market/market-status.enum';
import { fetchAllMarketTrades, fetchMarketOffersService, postScanTriggerRequestService } from 'services/market.service';
import { APPEND_MARKET_ITEMS, FETCH_MARKET_ITEMS, RESET_MARKET_DATA, SEND_SCAN_TRIGGER_REQUEST } from './actionNames/marketActionNames';

export const fetchMarketOffersAction = (filter: IMarketFilters) => ({
  type: FETCH_MARKET_ITEMS,
  payload: fetchMarketOffersService(filter),
});

export const appendMarketOffersAction = (filter: IMarketFilters) => ({
  type: APPEND_MARKET_ITEMS,
  payload: fetchMarketOffersService(filter),
});

export const fetchAllMarketOffersAction = (params: { statuses?: MarketStatus[]; search?: string }) => ({
  type: FETCH_MARKET_ITEMS,
  payload: fetchAllMarketTrades(params),
});

export const resetMarketDataAction = () => ({ type: RESET_MARKET_DATA });

export const postScanTriggerRequestAction = (): IDispatchAxiosAction => ({
  type: SEND_SCAN_TRIGGER_REQUEST,
  payload: postScanTriggerRequestService(),
});